import { Box, TextField } from "@mui/material";
import type { FC } from "react";
import type { FieldError } from "react-hook-form";
import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { Asset } from "../../../../assets/server/digital-asset-service";
import { AutoCompleteSelector } from "../../../../generic/components/auto-complete/auto-complete";
import type { TagGroup } from "../../../../merge-tag/components/types";
import type { MomentFormSurvey } from "../../../../survey/server/supabase-survey-service";
import { SurveySelectorDropdown } from "../survey/survey-selector-dropdown";
import { ButtonFormContentLibraryLink } from "./button-form-content-library-link";
import type { LinkType } from "./types";

type Props = {
  linkOption: LinkType;
  value: string | null;
  onChange: (value: string) => void;
  assetsLoader?: UseSupabaseLoaderState<Asset[]> & { reload: () => void };
  surveyLoader: UseSupabaseLoaderState<MomentFormSurvey[]>;
  error?: FieldError;
  filterTags: (x: string) => TagGroup;
};

export const StyleableButtonUrl: FC<Props> = ({
  linkOption,
  value,
  onChange,
  error,
  assetsLoader,
  filterTags,
  surveyLoader,
}) => {
  switch (linkOption.type) {
    case "link_url":
      return (
        <AutoCompleteSelector
          defaultValue={value || "https://"}
          filterTags={filterTags}
          onChange={onChange}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              id="url"
              label="Button Link"
              fullWidth
              variant="standard"
              value={value ?? ""}
              placeholder="https://www.example.com"
              onChange={(x) => {
                onChange(x.target.value);
              }}
              helperText={error?.message}
              error={Boolean(error)}
            />
          )}
        />
      );

    case "link_lib":
      return assetsLoader ? (
        <Box sx={{ mt: 3 }}>
          <ButtonFormContentLibraryLink
            onUseAsLink={(url) => {
              onChange(url);
            }}
            onRemoveLink={() => {
              onChange("");
            }}
            formError={error}
            assetsLoader={assetsLoader}
          />
        </Box>
      ) : null;

    case "link_survey":
      return (
        <SurveySelectorDropdown
          onChange={onChange}
          surveyLoader={surveyLoader}
          error={error}
          id={linkOption.id}
          channel={linkOption.channel}
        />
      );
  }
};
